// extracted by mini-css-extract-plugin
module.exports = {"img-wrapper":"gim2N","sub-wrapper":"Cma-h","image":"_2lENe","info":"_3OnfZ","group-name":"_2veDt","plan-name":"_3x1_G","expiry-date":"_3BrW1"};